import {types} from '../types/types';

const initialState = {
    openScreen: 'uiOpenDashboard',
    closeScreen: false,
    sidebar: false,
    loading: false,
    refreshKey: 0,
};

export const uiReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.uiOpenDashboard:
        case types.uiOpenListDevice:
        case types.uiOpenAddDevice:
        case types.uiOpenEditDevice:
        case types.uiOpenListUser:
        case types.uiOpenAddUser:
        case types.uiOpenEditUser:
        case types.uiOpenListDelivery:
        case types.uiOpenAddDelivery:
        case types.uiOpenEditDelivery:
        case types.uiOpenListUserGroup:
        case types.uiOpenAddUserGroup:
        case types.uiOpenEditUserGroup:
        case types.uiOpenListPaymentMethod:
        case types.uiOpenAddPaymentMethod:
        case types.uiOpenEditPaymentMethod:
        case types.uiOpenListProduct:
        case types.uiOpenAddProduct:
        case types.uiOpenEditProduct:
        case types.uiOpenListGroup:
        case types.uiOpenAddGroup:
        case types.uiOpenEditGroup:
        case types.uiOpenListCustomer:
        case types.uiOpenAddCustomer:
        case types.uiOpenEditCustomer:
        case types.uiOpenListCustomerGroup:
        case types.uiOpenAddCustomerGroup:
        case types.uiOpenEditCustomerGroup:
        case types.uiOpenAssociateCustomerGroupCustomer:
        case types.uiOpenAssociateCustomerGroupDevice:
        case types.uiOpenListDeliveryRouteGroup:
        case types.uiOpenAddDeliveryRouteGroup:
        case types.uiOpenEditDeliveryRouteGroup:
        case types.uiOpenAssociateDeliveryRouteGroupDelivery:
        case types.uiOpenAssociateDeliveryRouteGroupDevice:
        case types.uiOpenListPaymentMethodGroup:
        case types.uiOpenAddPaymentMethodGroup:
        case types.uiOpenEditPaymentMethodGroup:
        case types.uiOpenAssociatePaymentMethodGroupPaymentMethod:
        case types.uiOpenAssociatePaymentMethodGroupDevice:
        case types.uiOpenListDiscount:
        case types.uiOpenAddDiscount:
        case types.uiOpenEditDiscount:
        case types.uiOpenListProductGroup:
        case types.uiOpenAddProductGroup:
        case types.uiOpenEditProductGroup:
        case types.uiOpenAssociateProductGroupProduct:
        case types.uiOpenAssociateProductGroupDevice:
        case types.uiOpenAssociateUserGroupUser:
        case types.uiOpenAssociateUserGroupDevice:
        case types.uiOpenListDocument:
        case types.uiOpenAddDocument:
        case types.uiOpenEditDocument:
        case types.uiOpenDocumentDetails:
        case types.uiOpenListNCFRange:
        case types.uiOpenAddNCFRange:
        case types.uiOpenEditNCFRange:
        case types.uiOpenListNCFRangeGroup:
        case types.uiOpenAddNCFRangeGroup:
        case types.uiOpenEditNCFRangeGroup:
        case types.uiOpenAssociateNCFRangeGroupNCFRange:
        case types.uiOpenAssociateNCFRangeGroupDevice:
        case types.uiOpenListPrice:
        case types.uiOpenAddPrice:
        case types.uiOpenEditPrice:
        case types.uiOpenListTax:
        case types.uiOpenAddTax:
        case types.uiOpenEditTax:
        case types.uiOpenListTaxValue:
        case types.uiOpenAddTaxValue:
        case types.uiOpenEditTaxValue:
        case types.uiOpenListTaxProduct:
        case types.uiOpenAddTaxProduct:
        case types.uiOpenEditTaxProduct:
        case types.uiOpenListMeasurementUnit:
        case types.uiOpenAddMeasurementUnit:
        case types.uiOpenEditMeasurementUnit:
        case types.uiOpenListWarehouse:
        case types.uiOpenAddWarehouse:
        case types.uiOpenEditWarehouse:
        case types.uiOpenListWarehouseGroup:
        case types.uiOpenAddWarehouseGroup:
        case types.uiOpenEditWarehouseGroup:
        case types.uiOpenAssociateWarehouseGroupWarehouse:
        case types.uiOpenAssociateWarehouseGroupDevice:
        case types.uiOpenListDgiiCert:
        case types.uiOpenAddDgiiCert:
        case types.uiOpenEditDgiiCert:
        case types.uiOpenListProductHandlers:
        case types.uiOpenListProductHandlersGroup:
        case types.uiOpenEditProductHandler:
        case types.uiOpenEditProductHandlerGroup:
        case types.uiOpenScreen:

            // ... continuar con otros uiOpen* comunes
            return {
                ...state,
                openScreen: action.payload,
                closeScreen: false
            };

        case types.uiCloseCurrentScreen:
            return {
                ...state,
                closeScreen: action.payload
            };

        case types.uiSidebarActive:
            return {
                ...state,
                sidebar: action.payload
            };

        case types.loading:
            return { ...state, loading: Boolean(action.payload) };

        case types.refreshKey:
            return {
                ...state,
                refreshKey: action.payload
            };

        default:
            return state;
    }
};